import React, { FC, useRef, useState } from 'react';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { getBizNo, formatBizNo } from 'src/utils/charSet';
import NoResult from 'src/components/molecules/table/NoResult';
import { addComma } from 'src/utils/common';

interface Props {
  data: any;
  viewType?: string;
  modifyItemEvt: (item: any) => void;
  deleteItemEvt: (item: any) => void;
}
const GridList: FC<Props> = ({ data, viewType, modifyItemEvt, deleteItemEvt }) => {
  const viewData: any = [];
  data.forEach((item: any, idx: number) => {
    const infoData = item.infoData || [];
    infoData.forEach((info: any, i: number) => {
      const setItem = {
        ...item,
        infoData: info,
      };
      viewData.push(setItem);
    });
  });

  const setData = [];
  const deleteEvt = (item: any) => {
    deleteItemEvt(item);
  };
  const modifyEvt = (item: any) => {
    modifyItemEvt(item);
  };
  const viewDataType = (item: any) => {
    let typeView = '';
    switch (item) {
      case '1':
        typeView = '국세청 제공';
        break;
      case '2':
        typeView = '국민건강보험 공단';
        break;
      case '3':
        typeView = '진료비, 약제비';
        break;
      case '4':
        typeView = '장기요양급여 비용';
        break;
      case '5':
        typeView = '기타 의료비 영수증';
        break;
      default:
        typeView = '국세청 제공';
        break;
    }
    return <div>{typeView}</div>;
  };
  const viewDataOrigin = (item: any) => {
    let typeView = '';
    typeView = '의료비';
    console.log('item.glassyn::::', item);
    if (item.is_glass === 'Y') typeView = '안경구입';
    if (item.is_sf_practice === 'Y') typeView = '난임 시술비';
    if (item.is_prem_baby === 'Y') typeView = '선천성 미숙아';
    if (item.is_postpartum === 'Y') typeView = '산후조리원비';
    if (item.is_ph_insu === 'Y') typeView = '실손의료보험금';
    return <div>{typeView}</div>;
  };

  return (
    <div className="_table_grid_layout _medical_list_grid">
      <div className="_grid">
        <div className="_label">
          <div className="_row _i_h3">
            {viewType === 'modify' ? (
              <>
                <div className="_col _wd_n01 _hd_n01">
                  <div className="_tit"></div>
                </div>
              </>
            ) : (
              ''
            )}
            <div className="_col _wd_n0">
              <div className="_cont">성명</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">제공</div>
            </div>
            <div className="_col _wd_n2">
              <div className="_cont">종류</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">사업자번호</div>
            </div>
            <div className="_col _wd_n5">
              <div className="_cont">상호</div>
            </div>
            <div className="_col _wd_n4">
              <div className="_cont">PDF제외금액</div>
            </div>
            <div className="_col _wd_n4">
              <div className="_cont">의료비(일반)</div>
            </div>
            <div className="_col _wd_n4">
              <div className="_cont">의료비(국세청)</div>
            </div>
          </div>
        </div>
        {/* </div> */}

        <div className="_content">
          {viewData.map((item: any, idx: number) => {
            const info = item.infoData || {};
            return (
              <div className="_row _i_h2" key={idx}>
                {viewType === 'modify' ? (
                  <>
                    <div className="_col _wd_n01">
                      <div className="_cont">
                        <div className="_i_row ">
                          <div className="_i_col _w_p_50  _bor_r">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => modifyEvt(item)}
                                icon="ri-edit-box-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                          <div className="_i_col _w_p_50">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => deleteEvt(item)}
                                icon="ri-delete-bin-2-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )}
                <div className="_col _wd_n0">
                  <div className="_cont">{item.name}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{viewDataType(info.data_type)}</div>
                </div>
                <div className="_col _wd_n2">
                  <div className="_cont">{viewDataOrigin(info)}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{getBizNo(info.co_num)}</div>
                </div>
                <div className="_col _wd_n5">
                  <div className="_cont">{info.trade_nm}</div>
                </div>
                <div className="_col _wd_n4">
                  <div className="_cont">{addComma(info.expt_htx_pdf)}</div>
                </div>
                <div className="_col _wd_n4">
                  <div className="_cont">{addComma(info.amt)}</div>
                </div>
                <div className="_col _wd_n4">
                  <div className="_cont">{addComma(info.htx_amt)}</div>
                </div>
              </div>
            );
          })}
          {viewData.length === 0 ? <NoResult /> : ''}
        </div>
      </div>
    </div>
  );
};

export default GridList;
